<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{createForm.value.id ? "Update": "Create"}} Auto select Locator</h4>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" id="modal-body">
  <!-- Create/Edit Section -->
  <div class="mt-2">
    <form [formGroup]="createForm" (ngSubmit)="saveLocator()">
      <div class="row">
        <div class="col-3">
          <label for="component-name">Name</label>
          <input type="text" id="component-name" class="form-control form-control-sm" formControlName="name" required />
        </div>
        <div class="col-3">
          <label for="page-label">Select Page Label</label>
          <ng-select *ngIf="!isNewPageLabel" id="page-label" class="required custom-style" formControlName="pageLabel" [items]="pageLabelList" bindLabel="name" placeholder="Select Page Label" [searchable]="true" [clearable]="false">
          </ng-select>
          <input *ngIf="isNewPageLabel" type="text" id="page-label" class="form-control form-control-sm" [(ngModel)]="newPageLabelName" [ngModelOptions]="{standalone: true}" placeholder="Page Label Name" required />
          <input type="checkbox" [(ngModel)]="isNewPageLabel" [ngModelOptions]="{standalone: true}" style="margin-right: 8px;" (click)="pageLabelRequiredValidator(pageLabelControl)" /><span style="font-size: 12px;"><i>New Page Label</i></span>
        </div>
        <div class="col-3" *ngIf="!createForm.controls['useJquery'].value">
          <label for="locator-type">Locator Type</label>
          <ng-select class="custom-style" id="locator-type" formControlName="locatorType" [items]="uiMeta.locatorTypes" placeholder="Select" [searchable]="true">
            <ng-option [value]="">Select</ng-option>
          </ng-select>
        </div>
        <div class="col-3">
          <label for="component-type">Component Type</label>
          <ng-select class="custom-style" id="component-type" formControlName="componentType" [items]="uiMeta.componentTypes" placeholder="Select" [searchable]="true" [clearable]="false"></ng-select>
        </div>
        <div class="col-3">
          <label for="locator-path">Path</label>
          <input type="text" id="locator-path" class="form-control form-control-sm" formControlName="locatorString" required />
        </div>
        <div class="col-12" *ngIf="createForm.value.shadowDom">
          <label for="locator-path">Parent Locator</label>

          <ng-select class="custom-style" [attr.data-items]="shadowDomLocatorList | customList:'name'" [attr.data-locator]="'locators'" [attr.data-value]="createForm.value.parentLocator?.name" chosen name="locator" formControlName="parentLocator" [items]="shadowDomLocatorList" bindLabel="name" [clearable]="false" placeholder="Select" [searchable]="true">
            <ng-template ng-option-tmp let-item="item">
              <div title="{{item.name}}" class="text-truncate">{{item.name}}</div>
            </ng-template>
          </ng-select>
          
        </div>
        <div *ngIf="createForm.value.shadowDom" class="col-sm-12 mt-2" style="overflow-x: auto;padding-top: 5px;padding-bottom: 10px;">
          <ng-container *ngIf="createForm.value.parentLocator" style="display: flex;">
              <ng-container [ngTemplateOutlet]="parentLocatorTemplate"
                  [ngTemplateOutletContext]="{ locator: createForm.value.parentLocator }"></ng-container>
          </ng-container>

          <ng-template #parentLocatorTemplate let-locator="locator">
              <div style="display: flex;">
                <div class="arrow-div"> {{locator.name}} </div>
                  <div *ngIf="locator.parentLocator" style="display: flex;">
                      <ng-container [ngTemplateOutlet]="parentLocatorTemplate"
                          [ngTemplateOutletContext]="{ locator: locator.parentLocator }"></ng-container>
                  </div>
              </div>
          </ng-template>
      </div>
        <div class="col-12 mt-2">
          <input type="checkbox" name="" id="locator-useJquery" formControlName="useJquery"> Use JQuery
          <input class="ml-2" type="checkbox" name="" id="locator-baseLocator" formControlName="baseLocator"> Base Locator
          <input style="margin-left: 2em;" type="checkbox" name="" id="shadowDom" formControlName="shadowDom" (click)="getShadowDomLocators($event)"> Shadow Dom
          <input style="margin-left: 2em;" type="checkbox" name="" id="shadowRoot" *ngIf="createForm.value.shadowDom" formControlName="shadowRoot"> 
           <span *ngIf="createForm.value.shadowDom"> Shadow Root</span>
        </div>
        <div class="col-12 text-right">
          <button type="submit" id="save-locator" class="btn relay-btn relay-createbtn" [ngClass]="createForm.value.id ?'update':'create'" [disabled]="!createForm.valid || (isNewPageLabel && (newPageLabelName === undefined || newPageLabelName === ''))">{{createForm.value.id ? "Update": "Create"}}</button>
          <button type="button" id="cancel-locator" class="btn relay-btn cancel" (click)="cancelCreateForm()" (click)="close()">Cancel</button>
        </div>
      </div>
    </form>
  </div>

  
</div>